import { Component } from "@angular/core";

@Component({
	selector: 'app-terms-bottom-sheet',
	templateUrl: './terms-bottom-sheet.component.html',
	styleUrls: ['./terms-bottom-sheet.component.scss'],
})
export class TermsBottomSheetComponent {}